<template>
    <SmartLinkItemComponent custom-tag="div" class="basic-content-section" v-if="model" :id="`_${model.system.id}`"
        :component="!model.system.workflow">
        <div :class="`container ${paddingOptions(data.paddingModifications)}`">
            <div class="row">
                <div class="col-lg">
                    <SmartLinkStandaloneElement custom-tag="div" class="content"
                        :codename="type.elements.content.codename">
                        <RichText :value="model.elements.content.value" />
                    </SmartLinkStandaloneElement>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { type BasicContentSectionModel, contentTypes } from '~/models';
const type = contentTypes.basic_content_section;
const props = defineProps<{ model: BasicContentSectionModel }>();

const data = computed(() => {
    return {
        content: props.model.elements.content.value,
        paddingModifications: props.model.elements.paddingModificationsPaddingModifications.value.map((item) => item.codename)
    }
});
</script>